<app-guest-auth-main-layout>
  <ng-template>
    <div class="  px-5 py-4 rounded-md shadow-lg">
      <h2 class="!text-lg !text-center !text-primary-500 !font-bold">{{"Hakiki OTP" |concat|translate }}</h2>
      <p class="">{{"OTP imetumwa kwenye namba yako ya simu. Tafadhali angalia ujumbe wako. Itakuwa halali kwa dakika tano zijazo." |concat|translate }}</p>
      <p *ngIf="!isTimerExpired" class="timer-message mb-3 ">
       {{"Muda Uliobakia " |concat|translate }}: <span
        class="!bg-gray-100 px-2 py-1 rounded-md font-semibold text-gray-700">{{ formattedTime }}</span>
      </p>
      <p *ngIf="isTimerExpired" class="error-message mb-2">
       {{"OTP imekwisha muda wake. Tafadhali omba mpya" |concat|translate }}
      </p>
      <form [formGroup]="otpForm" (ngSubmit)="verifyOtp(otpForm.value)">
        <div class="flex mt-3 justify-center">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{"Weka OTP" |concat|translate }}</mat-label>
            <input
              type="text"
              class="rounded-md text-center"
              formControlName="otp"
              [showMaskTyped]="true"
              mask="0-0-0-0-0-0"
              matInput
            />
          </mat-form-field>
        </div>
        <div class="flex w-full mt-1 items-center justify-center">
          <button type="submit" mat-raised-button class="!bg-primary-500 w-full !text-white"
                  [disabled]="!otpForm.valid"> {{"Verify" |concat|translate }}
          </button>
        </div>
      </form>
      <button *ngIf="isTimerExpired" [disabled]="!isTimerExpired" mat-raised-button
              class="!bg-primary-500 !text-white w-full mt-2" (click)="resetTimer()">
        {{"Resend OTP" |concat|translate }}
      </button>
      <p *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>

  </ng-template>
</app-guest-auth-main-layout>
